import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AccountPlanMessageModal from "./account-plan-message-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import HandleModalShowMixin from "@Broker/@Modules/account-plan/mixins/handle-modal-show-mixin";
import { getPlanDetails } from "@Shared/@Utils/utils";
import { PLAN_NAMES } from "@Shared/@Utils/constants";
import AccountPlanPerks from "../account-plan-perks.vue";
import { mapGetters } from "vuex";
import { ACCOUNT_EXPIRATION_DATE } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CancelPlanConfirmation",
  components: {
    AccountPlanMessageModal,
    SimpleButton,
    AccountPlanPerks
  },
  mixins: [HandleModalShowMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isCurrentSubscription: {
      type: Boolean,
      default: false
    },
    agentName: {
      type: String,
      default: ""
    },
    numberOfAgents: {
      type: Number,
      default: null
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [ACCOUNT_EXPIRATION_DATE])), {}, {
    formattedAccountExpiration() {
      return this.$options.filters.formatDateExpiration(this.ACCOUNT_EXPIRATION_DATE);
    },
    freeAccountPlan() {
      return getPlanDetails(PLAN_NAMES.FREE);
    },
    titleText() {
      return this.isCurrentSubscription ? this.$t("account.accountPlan.planModals.cancelConfirmation.title") : this.$tc("account.accountPlan.planModals.cancelConfirmation.titleManage", this.numberOfAgents, {
        agents: this.agentsText
      });
    },
    bodyText() {
      return this.isCurrentSubscription ? "account.accountPlan.planModals.cancelConfirmation.bodyText" : "account.accountPlan.planModals.cancelConfirmation.bodyManageText";
    },
    agentsText() {
      return this.agent || this.$tc("account.accountPlan.planModals.cancelConfirmation.nameAndOtherAgent", this.numberOfAgents, {
        agentName: this.agentName,
        numberOfAgents: this.numberOfAgents
      });
    }
  })
});